import { ClientSummaryNode } from '../../../generated/webapp_gql';
import { InsuranceStatus } from '../../../constants';

export const getHpiCoverageDisplayMsg = (client: ClientSummaryNode) => {
  if (!client.isCompanyHpiEnabled) return InsuranceStatus.NOT_ELIGIBLE;

  return client.memberInsuranceStatus;
};

export const getMedicationManagementDisplayMsg = (client: ClientSummaryNode) => {
  return client.isCompanyPsychiatryEnabled ? 'Available' : 'Not available';
};
